import { motion } from "framer-motion";
import { Link } from "react-router-dom";
const awardCloseup = "/images/site/reclaimed-barnwood-floor-rubio-monocoat-farmington-hills-mi.webp";

const AwardSection = () => (
  <section className="bg-foreground py-16 md:py-24 lg:py-32">
    <div className="max-w-[1200px] mx-auto px-5 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-14 items-center">
        {/* Column 1  Image */}
        <motion.div
          initial={{ opacity: 0, x: -32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <div className="rounded-[20px] overflow-hidden relative group">
            <img width={800} height={534} loading="lazy"
              src={awardCloseup}
              alt="Reclaimed barnwood floor with a Rubio Monocoat finish, Farmington Hills, MI"
              className="w-full aspect-[4/3] object-cover transition-all duration-700 ease-out grayscale-[20%] contrast-[1.1] group-hover:grayscale-0 group-hover:scale-[1.04]"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground/80 via-foreground/40 to-transparent p-4 pt-12 md:p-5 md:pt-16">
              <h3 className="font-display text-sm md:text-base font-semibold text-primary-foreground leading-tight">Reclaimed Barnwood, Rubio Monocoat White 2C Oil</h3>
              <p className="text-[10px] md:text-xs tracking-[.12em] uppercase text-primary-foreground/70 mt-1">Farmington Hills, Michigan</p>
            </div>
          </div>
        </motion.div>

        {/* Column 2  Text & Award */}
        <motion.div
          initial={{ opacity: 0, x: 32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
        >
          <p className="text-[10px] md:text-[11px] font-semibold tracking-[.18em] uppercase text-primary mb-4">
            🏆 National Recognition&nbsp;&nbsp;2017
          </p>
          <h2 className="font-display text-[clamp(26px,4vw,44px)] font-semibold text-primary-foreground leading-[1.12]">
            NWFA Wood Floor of the Year.{" "}
            <em className="italic font-normal text-primary">Renovation &amp; Restoration.</em>
          </h2>
          <p className="mt-5 text-sm md:text-[15px] font-light text-muted-foreground/80 leading-relaxed max-w-lg">
            Our founder, Ed Malaski, was named the national winner. Chosen from submissions across the entire country for this reclaimed barnwood floor and custom stair set. Recognized by Wood Floor Business Magazine, the NWFA, and Rubio Monocoat USA, this project represents the standard we bring to every home we touch.
          </p>
          <Link
            to="/reclaimed-barnwood"
            className="mt-8 inline-flex items-center gap-2 bg-primary text-primary-foreground px-7 py-3 rounded-full text-sm font-medium hover:bg-primary/90 transition-colors"
          >
            Explore Reclaimed Barnwood Products →
          </Link>
        </motion.div>
      </div>
    </div>
  </section>
);

export default AwardSection;
